import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';
import { getCachedData, invalidateCacheByPrefix, CACHE_KEYS } from '../funciones/apiCache';

const API_URL = process.env.REACT_APP_API_URL;

const PERIODOS_CACHE_TTL = 30 * 60 * 1000;

export const fetchPeriodosVerano = async (params = {}, forceRefresh = false) => {
    const paramsSuffix = params.anio ? `_anio_${params.anio}` : '_all';
    const cacheKey = `${CACHE_KEYS.PERIODOS_VERANO}${paramsSuffix}`;

    const fetchFn = async () => {
        const response = await axios.get(`${API_URL}/api/periodos-verano`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params: { ...params, _t: Date.now() }
        });
        return response.data;
    };

    try {
        if (forceRefresh) {
            invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO);
        }
        return await getCachedData(cacheKey, fetchFn, PERIODOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Obtener periodo de verano actual
export const fetchPeriodoActual = async () => {
    const cacheKey = `${CACHE_KEYS.PERIODOS_VERANO}_actual`;

    const fetchFn = async () => {
        const response = await axios.get(`${API_URL}/api/periodos-verano/actual`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            },
            params: { _t: Date.now() }
        });
        return response.data;
    };

    try {
        return await getCachedData(cacheKey, fetchFn, PERIODOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Obtener periodo por ID
export const fetchPeriodoVerano = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/periodos-verano/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Crear periodo de verano
export const crearPeriodoVerano = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/api/periodos-verano`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Actualizar periodo de verano
export const actualizarPeriodoVerano = async (id, data) => {
    try {
        const response = await axios.put(`${API_URL}/api/periodos-verano/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Eliminar periodo de verano
export const eliminarPeriodoVerano = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/periodos-verano/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.PERIODOS_VERANO);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
